const u = (id) => `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1200&q=80`;

export const IMAGES = {
    hero: u("photo-1519869325930-281384150729"),
    cupcakeVariety: u("photo-1565498253128-c06e0488ddee"),
    chocolateCupcake: u("photo-1640806353257-6c408529d822"),
    pinkCake: u("photo-1604413191066-4dd20bedf486"),
    chocolateCake: u("photo-1606983340126-99ab4feaa64a"),
    cookies: u("photo-1726733995322-13779de0111f"),
    cheesecake: u("photo-1708175313856-8573b2bf8a3a"),
    baker: u("photo-1758874960663-af6534a4acd3"),
    decorating: u("photo-1644842939226-1545819960e1"),
    realPawPatrol: "/real-cake-butterfly.jpg",
    realGeode: "/real-cake-pawpatrol.webp",
    realMarble: "/real-cake-marble.webp",
    realPretzels: "/real-sweets-pretzels.jpg",
    realMonsterTruck: "/real-cake-monstertruck.webp",
    realSeahawks: "/real-cake-seahawks.jpg",
    realStrawberries: "/real-sweets-strawberries.webp",
    realMiniCheesecakes: "/real-mini-cheesecakes.webp",
    realCookies: "/real-cookies.webp",
    realCupcakes: "/real-cupcakes-strawberry.jpg",
    realAnnabell: "/real-annabell.webp",
};

export const CUSTOM_ORDER_VIDEO = {
    src: "/real-custom-order.mp4",
    poster: "/real-custom-order-poster.jpg",
    alt: "A custom order made by Annabell",
};

export const CUSTOM_ORDER_VIDEO_2 = {
    src: "/real-custom-order-2.mp4",
    poster: "/real-custom-order-2-poster.jpg",
    alt: "Custom number cake and cupcakes made by Annabell",
};

export const BASIC_FLAVORS = ["Vanilla", "Chocolate", "Strawberry", "Lemon"];

export const FANCY_FLAVORS = [
    "Black Bottom",
    "Strawberry Shortcake",
    "Orange Creamsicle",
    "German Chocolate",
    "Lemon Bar",
    "Chocolate & Peanut Butter",
    "Chocolate & Cream",
    "Strawberries & Cream",
    "Chocolate Raspberry",
];

export const FROSTING_OPTIONS = [
    "Bettercream",
    "Chocolate Buttercream",
    "Vanilla Buttercream",
    "German Chocolate",
    "Ganache",
];

export const CAKE_FLAVORS = ["Vanilla", "Chocolate", "Strawberry", "Lemon", "Carrot Cake"];

export const CAKE_PRICING = {
    columns: ['4"', '6"', '8"', '10"'],
    rows: [
        { label: "2 Layer", values: ["$20", "$40", "$60", "—"] },
        { label: "3 Layer", values: ["$30", "$50", "$70", "$90"] },
        { label: "4 Layer", values: ["$40", "$60", "$80", "$100"] },
    ],
};

export const COOKIE_FLAVORS = [
    "Chocolate Chip",
    "Peanut Butter",
    "Snickers",
    "Reese's",
    "Butterfinger",
    "Snickerdoodle",
    "Oatmeal",
    "Riesen",
];

export const COOKIE_PRICING = [
    { name: "Classic Cookies", price: "$20", per: "per dozen", detail: "Chocolate chip, peanut butter, Snickers, Reese's, Butterfinger, snickerdoodle, oatmeal, Riesen, and more" },
    { name: "Monster Cookies", price: "$25", per: "per dozen" },
    { name: "Decorated Sugar Cookies", price: "$40", per: "per dozen" },
];

export const SWEET_TREAT_PRICING = [
    { name: "Chocolate-Covered Strawberries", price: "$25", per: "per dozen" },
    { name: "Chocolate-Covered Pretzels", price: "$25", per: "per dozen" },
    { name: "Oreo Balls", price: "$25", per: "per dozen" },
    { name: "Lemon Bars", price: "$25", per: "per dozen" },
    { name: "Brownies", price: "$25", per: "per dozen" },
    { name: "Rice Crispy Treats", price: "$25", per: "per dozen" },
];

export const CHEESECAKE_FLAVORS = ["Chocolate Chip", "Chocolate", "Raspberry Swirl"];

export const CHEESECAKE_PRICING = {
    columns: ['4"', '6"', '8"'],
    rows: [
        { label: "Plain", values: ["$20", "$30", "$40"] },
        { label: "Flavored", values: ["$30", "$40", "$50"] },
    ],
};

export const CHAPTERS = [
    {
        number: "01",
        heading: "A Love for Baking",
        body: "What started with a love for baking has grown into creating homemade desserts for family, friends, celebrations, and special moments.",
    },
    {
        number: "02",
        heading: "Personal Attention, Every Order",
        body: "From a dozen cupcakes for a family gathering to a custom birthday cake or a box of chocolate-covered treats, every order receives personal attention.",
    },
    {
        number: "03",
        heading: "As Good As They Look",
        body: "We believe homemade desserts should taste just as good as they look. Homemade, fresh, and always made with love.",
    },
];

export const TREATS = [
    {
        slug: "cupcakes",
        name: "Cupcakes",
        tag: "From $25 / dozen",
        image: IMAGES.realCupcakes,
        description: "Basic or fancy, filled and decorated — a dozen little reasons to celebrate.",
    },
    {
        slug: "custom-cakes",
        name: "Custom Cakes",
        tag: "From $20",
        image: IMAGES.realGeode,
        description: "2, 3, or 4 layers in 4\" to 10\" — birthdays, holidays, weddings, baby showers, and more.",
    },
    {
        slug: "cookies",
        name: "Cookies",
        tag: "From $20 / dozen",
        image: IMAGES.realCookies,
        description: "Classic favorites, monster cookies, and decorated sugar cookies — all baked fresh.",
    },
    {
        slug: "cheesecakes",
        name: "Cheesecakes",
        tag: "From $20",
        image: IMAGES.realMiniCheesecakes,
        description: "Plain or flavored, in 4\", 6\", and 8\" — creamy homemade cheesecakes for any gathering.",
    },
    {
        slug: "sweet-treats",
        name: "Sweet Treats",
        tag: "$25 / dozen",
        image: IMAGES.realStrawberries,
        description: "Chocolate-covered strawberries and pretzels, Oreo balls, lemon bars, brownies, and rice crispy treats.",
    },
];

export const TREAT_DETAILS = {
    cupcakes: {
        name: "Cupcakes",
        script: "baked by the dozen",
        hero: IMAGES.realCupcakes,
        intro: "Basic when you want something simple and delicious — fancy when you want to take it to the next level. Every dozen is baked fresh and frosted by hand.",
        includes: [
            "Basic Cupcakes — $25 per dozen: no filling, one frosting color, no decorations",
            "Fancy Cupcakes — $40 per dozen: filling, up to two frosting colors, and decorations",
        ],
        flavorsTitle: "Basic flavors",
        flavors: BASIC_FLAVORS,
        extraFlavorsTitle: "Fancy flavors",
        extraFlavors: [...FANCY_FLAVORS, "…and more — just ask!"],
        images: [
            { src: IMAGES.realCupcakes, alt: "Strawberry shortcake cupcakes made by Annabell" },
            { src: IMAGES.realMiniCheesecakes, alt: "Mini cheesecakes made by Annabell" },
            { src: IMAGES.realStrawberries, alt: "Chocolate-covered strawberries made by Annabell" },
        ],
    },
    "custom-cakes": {
        name: "Custom Cakes",
        script: "made for your moment",
        hero: IMAGES.realGeode,
        intro: "Need a cake for a birthday, celebration, holiday, or special event? Tell us what you have in mind — from themed birthday cakes to elegant geode designs, every cake is made just for you.",
        includes: [
            "Choose 2, 3, or 4 layers in 4\", 6\", 8\", or 10\"",
            "Designed around your theme, colors, and occasion",
            "Frosted with bettercream unless otherwise requested",
        ],
        priceTable: CAKE_PRICING,
        priceTableTitle: "Cake pricing",
        notes: [
            "Fondant adds $20–40 per order",
            "Bettercream frosting is our house standard unless you'd like something else",
        ],
        flavorsTitle: "Cake flavors",
        flavors: [...CAKE_FLAVORS, "Flavor requests welcome!"],
        extraFlavorsTitle: "Frosting options",
        extraFlavors: FROSTING_OPTIONS,
        images: [
            { src: IMAGES.realPawPatrol, alt: "Paw Patrol birthday cakes made by Annabell" },
            { src: IMAGES.realGeode, alt: "Geode butterfly cake made by Annabell" },
            { src: IMAGES.realMarble, alt: "Blue marble butterfly cake made by Annabell" },
            { src: IMAGES.realMonsterTruck, alt: "Monster truck birthday cake made by Annabell" },
            { src: IMAGES.realSeahawks, alt: "Seahawks cake made by Annabell" },
            { video: CUSTOM_ORDER_VIDEO, alt: "A custom order made by Annabell" },
            { video: CUSTOM_ORDER_VIDEO_2, alt: "Custom number cake and cupcakes made by Annabell" },
        ],
    },
    cookies: {
        name: "Cookies",
        script: "fresh from the oven",
        hero: IMAGES.realCookies,
        intro: "Homemade cookies baked fresh for gatherings, holidays, and sweet cravings — from classic favorites to monster cookies and decorated sugar cookies.",
        includes: [
            "Baked fresh to order",
            "Perfect for parties, holidays, and gifting",
        ],
        priceList: COOKIE_PRICING,
        priceListTitle: "Cookie pricing",
        flavorsTitle: "Classic cookie flavors",
        flavors: [...COOKIE_FLAVORS, "…and more — just ask!"],
        images: [
            { src: IMAGES.realCookies, alt: "Homemade cookies made by Annabell" },
            { src: IMAGES.realStrawberries, alt: "Chocolate-covered strawberries made by Annabell" },
            { src: IMAGES.realPretzels, alt: "Chocolate-covered pretzels made by Annabell" },
        ],
    },
    cheesecakes: {
        name: "Cheesecakes",
        script: "rich & creamy",
        hero: IMAGES.realMiniCheesecakes,
        intro: "Creamy homemade cheesecakes for celebrations, holidays, or a well-earned treat — plain or flavored, in 4\", 6\", and 8\".",
        includes: [
            "Made fresh to order",
            "Great for holidays, showers, and special dinners",
        ],
        priceTable: CHEESECAKE_PRICING,
        priceTableTitle: "Cheesecake pricing",
        flavorsTitle: "Flavored cheesecakes",
        flavors: [...CHEESECAKE_FLAVORS, "…and more — just ask!"],
        images: [
            { src: IMAGES.realMiniCheesecakes, alt: "Mini cheesecakes made by Annabell" },
            { src: IMAGES.realCookies, alt: "Homemade cookies made by Annabell" },
            { src: IMAGES.realStrawberries, alt: "Chocolate-covered strawberries made by Annabell" },
        ],
    },
    "sweet-treats": {
        name: "Sweet Treats",
        script: "& a little more",
        hero: IMAGES.realStrawberries,
        intro: "Chocolate-covered strawberries and pretzels, Oreo balls, lemon bars, brownies, and rice crispy treats — perfect for dessert tables, gifting, and parties. Have an idea? We'd love to hear it.",
        includes: [
            "Everything $25 per dozen",
            "Custom sweets for dessert tables and events",
        ],
        priceList: SWEET_TREAT_PRICING,
        priceListTitle: "Sweet treat pricing",
        images: [
            { src: IMAGES.realStrawberries, alt: "Chocolate-covered strawberries made by Annabell" },
            { src: IMAGES.realPretzels, alt: "Chocolate-covered pretzels made by Annabell" },
            { src: IMAGES.realCupcakes, alt: "Strawberry shortcake cupcakes made by Annabell" },
            { src: IMAGES.realCookies, alt: "Homemade cookies made by Annabell" },
        ],
    },
};

export const GALLERY = [
    { src: IMAGES.realPawPatrol, alt: "Paw Patrol birthday cakes made by Annabell", span: "md:col-span-2 md:row-span-2" },
    { src: IMAGES.realGeode, alt: "Geode butterfly cake made by Annabell", span: "md:col-span-2" },
    { src: IMAGES.realMonsterTruck, alt: "Monster truck birthday cake made by Annabell", span: "" },
    { src: IMAGES.realMarble, alt: "Blue marble butterfly cake made by Annabell", span: "md:row-span-2" },
    { src: IMAGES.realPretzels, alt: "Chocolate-covered pretzels made by Annabell", span: "" },
    { video: CUSTOM_ORDER_VIDEO, alt: "A custom order made by Annabell", span: "" },
    { src: IMAGES.realStrawberries, alt: "Chocolate-covered strawberries made by Annabell", span: "" },
    { src: IMAGES.realCupcakes, alt: "Strawberry shortcake cupcakes made by Annabell", span: "" },
    { video: CUSTOM_ORDER_VIDEO_2, alt: "Custom number cake and cupcakes made by Annabell", span: "md:row-span-2" },
    { src: IMAGES.realSeahawks, alt: "Seahawks cake made by Annabell", span: "" },
];

export const FAQS = [
    {
        q: "How do I place an order?",
        a: "Fill out the order request form with your date, treats, and ideas, or call or text us at (360) 402-6800. Annabell will personally review your request and reach out to confirm availability and pricing — no order is final until we've talked details.",
    },
    {
        q: "Is my order confirmed when I submit the form?",
        a: "Not yet. Submitting the form sends us your request, and we confirm availability and pricing with you afterward. Every order gets personal attention before it's booked.",
    },
    {
        q: "What areas do you serve?",
        a: "We happily serve Shelton, Olympia, Lacey, and surrounding Washington areas.",
    },
    {
        q: "Do you offer pickup or delivery?",
        a: "Both! You can pick up your order, or we can deliver to you for a small delivery fee. We'll arrange the details when your order is confirmed.",
    },
    {
        q: "What cupcake flavors do you offer?",
        a: "Basic cupcakes come in Vanilla, Chocolate, Strawberry, and Lemon. Fancy cupcakes include Black Bottom, Strawberry Shortcake, Orange Creamsicle, German Chocolate, Lemon Bar, Chocolate & Peanut Butter, and more. Have another flavor in mind? Just ask!",
    },
    {
        q: "What frosting options do you have for cakes?",
        a: "Our house standard is bettercream frosting unless you'd prefer something else — we also offer chocolate buttercream, vanilla buttercream, German chocolate, and ganache. Fondant is available for $20–40 extra per order.",
    },
    {
        q: "How much are your cakes?",
        a: "Cakes are priced by layers and size. 2-layer: 4\" $20, 6\" $40, 8\" $60. 3-layer: 4\" $30, 6\" $50, 8\" $70, 10\" $90. 4-layer: 4\" $40, 6\" $60, 8\" $80, 10\" $100. Flavors include vanilla, chocolate, strawberry, lemon, and carrot cake — and we take flavor requests! Fondant adds $20–40 per order.",
    },
    {
        q: "How much are cookies?",
        a: "Classic cookies (chocolate chip, peanut butter, Snickers, Reese's, Butterfinger, snickerdoodle, oatmeal, Riesen, and more) are $20 per dozen. Monster cookies are $25 per dozen, and decorated sugar cookies are $40 per dozen.",
    },
    {
        q: "How much are cheesecakes?",
        a: "Plain cheesecakes are 4\" $20, 6\" $30, 8\" $40. Flavored cheesecakes (chocolate chip, chocolate, raspberry swirl, and more) are 4\" $30, 6\" $40, 8\" $50.",
    },
    {
        q: "What sweet treats do you offer?",
        a: "Chocolate-covered strawberries, chocolate-covered pretzels, Oreo balls, lemon bars, brownies, and rice crispy treats — each $25 per dozen. Perfect for gifting, dessert tables, and parties.",
    },
    {
        q: "Can you make a custom cake for my event?",
        a: "Absolutely — birthdays, celebrations, holidays, weddings, baby showers, and special events. Tell us what you have in mind through the order request form and we'll dream it up together.",
    },
];

export const TESTIMONIALS = [
    {
        name: "Angela Guzman-Tucker",
        source: "Facebook",
        occasion: "Korean-style cakes for a 100 Day Birthday Celebration",
        quote: "I would highly recommend Annabell Thomas of Annabells Cupcakes and More for your baking needs! She did an amazing job making DELICIOUS Korean style cakes for Attiyana's 100 Day Birthday Celebration and used her creativity to decorate them to suit Attiyana.",
    },
    {
        name: "Jena Crooks",
        source: "Facebook",
        occasion: "Pumpkin surprise & black bottom cupcakes for Thanksgiving",
        quote: "My friend Annabell Thomas has her own business for yummy treats! We ordered pumpkin surprise and black bottom cupcakes for Thanksgiving and they are amazing! You won't be disappointed!",
    },
];

export const PHONE_NUMBER = "(360) 402-6800";
export const PHONE_TEL = "+13604026800";

export const FACEBOOK_URL = "https://www.facebook.com/share/1DYTTJysdF/?mibextid=wwXIfr";

export const MARQUEE_ITEMS = [
    "Homemade With Love",
    "Fresh & Small Batch",
    "Custom Cakes & Cupcakes",
    "Shelton · Olympia · Lacey",
    "Pickup & Local Delivery",
    "Made for Every Occasion",
];

export const ORDER_CATEGORIES = [
    "Basic Cupcakes",
    "Fancy Cupcakes",
    "Custom Cake",
    "Carrot Cake",
    "Classic Cookies",
    "Monster Cookies",
    "Decorated Sugar Cookies",
    "Cheesecake",
    "Chocolate-Covered Strawberries",
    "Chocolate-Covered Pretzels",
    "Oreo Balls",
    "Lemon Bars",
    "Brownies",
    "Rice Crispy Treats",
    "Something Else",
];
